import { IS_STG, IS_MOBILE } from "../../data/js/server-constants"
import Script from "next/script";

const OneTrust = () => {
	if (IS_MOBILE) return ''
	return (
		 <>
			<Script
				crossOrigin="anonymous"
				strategy="afterInteractive"
				data-document-language="true"
				data-domain-script={`b4b900fb-2b18-49cc-8667-d2e055fa2f8f${
					IS_STG ? "-test" : ""
				}`}
				src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
			/>
			<Script
				id="one-trust"
				strategy="afterInteractive"
				dangerouslySetInnerHTML={{
					__html: `
				try {
					function OptanonWrapper() { }
				} catch (e) {
					console.log('OneTrust Error: ', e)
				}`,
				}}
			/>
		</>
	);
};

export default OneTrust;
